<div class="ckeditor-main-container">
  <div *ngIf="isLoading" class="editor-loading-indicator">
    Chargement de l'éditeur...
  </div>

  <!-- Container for dynamic component injection -->
  <ng-container #editorContainer></ng-container>
</div>